import { useEffect, useId, useRef, type ReactNode } from "react";

/** Native modal focus trapping, Escape dismissal and focus restoration. */
export function ForestModal({ title, onClose, children }: { title: string; onClose(): void; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const id = useId();
  useEffect(() => {
    const dialog = ref.current!;
    const previous = document.activeElement as HTMLElement | null;
    dialog.showModal();
    dialog.querySelector<HTMLElement>("[data-modal-autofocus]")?.focus();
    return () => { dialog.close(); queueMicrotask(() => { if (previous?.isConnected) previous.focus(); }); };
  }, []);
  return <dialog ref={ref} className="forest-modal" aria-labelledby={id}
    onCancel={e => { e.preventDefault(); onClose(); }}
    onKeyDown={e => e.stopPropagation()}
    onClick={e => { if (e.target === e.currentTarget) { const rect = e.currentTarget.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) onClose(); } }}>
    <header><div><span className="forest-eyebrow">POKÉMON CHAIN</span><h2 id={id}>{title}</h2></div><button aria-label="Close popup" onClick={onClose}>×</button></header>
    <div className="forest-modal-body">{children}</div>
  </dialog>;
}
